/* This is generated code, don't alter */
var IfcVoidingFeatureTypeEnum;
(function (IfcVoidingFeatureTypeEnum) {
    IfcVoidingFeatureTypeEnum[IfcVoidingFeatureTypeEnum["CUTOUT"] = 0] = "CUTOUT";
    IfcVoidingFeatureTypeEnum[IfcVoidingFeatureTypeEnum["NOTCH"] = 1] = "NOTCH";
    IfcVoidingFeatureTypeEnum[IfcVoidingFeatureTypeEnum["HOLE"] = 2] = "HOLE";
    IfcVoidingFeatureTypeEnum[IfcVoidingFeatureTypeEnum["MITER"] = 3] = "MITER";
    IfcVoidingFeatureTypeEnum[IfcVoidingFeatureTypeEnum["CHAMFER"] = 4] = "CHAMFER";
    IfcVoidingFeatureTypeEnum[IfcVoidingFeatureTypeEnum["EDGE"] = 5] = "EDGE";
    IfcVoidingFeatureTypeEnum[IfcVoidingFeatureTypeEnum["USERDEFINED"] = 6] = "USERDEFINED";
    IfcVoidingFeatureTypeEnum[IfcVoidingFeatureTypeEnum["NOTDEFINED"] = 7] = "NOTDEFINED";
})(IfcVoidingFeatureTypeEnum || (IfcVoidingFeatureTypeEnum = {}));
const IfcVoidingFeatureTypeEnumCount = 8;
export { IfcVoidingFeatureTypeEnum, IfcVoidingFeatureTypeEnumCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapIfcVoidingFeatureTypeEnum = new Int32Array([1, -1, 4]);
let prefixSumAddressIfcVoidingFeatureTypeEnum = new Uint32Array([0, 6, 15, 27, 34, 42, 48, 61, 68]);
let slotMapIfcVoidingFeatureTypeEnum = new Int32Array([2, 4, 7, 1, 0, 5, 6, 3]);
let encodedDataIfcVoidingFeatureTypeEnum = (new TextEncoder()).encode(".HOLE..CHAMFER..NOTDEFINED..NOTCH..CUTOUT..EDGE..USERDEFINED..MITER.");
let IfcVoidingFeatureTypeEnumSearch = new MinimalPerfectHash(gMapIfcVoidingFeatureTypeEnum, prefixSumAddressIfcVoidingFeatureTypeEnum, slotMapIfcVoidingFeatureTypeEnum, encodedDataIfcVoidingFeatureTypeEnum);
export { IfcVoidingFeatureTypeEnumSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function IfcVoidingFeatureTypeEnumDeserializeStep(input, cursor, endCursor) {
    return parser.extract(IfcVoidingFeatureTypeEnumSearch, input, cursor, endCursor);
}
